import React from "react";
import { ButtonV2 } from "../../ButtonV2";
export const Overlay = ({ modalMessage, handleVisibility, modalButtonMessage, modalButtonUrl }) => (React.createElement("div", { className: 'overlay-wrapper' },
    React.createElement("div", { className: "overlay-wrapper__modal-wrapper" },
        React.createElement("div", { className: "modal-message", dangerouslySetInnerHTML: { __html: modalMessage } }),
        React.createElement(ButtonV2, { onClick: handleVisibility, design: "cta-large-wbg", href: modalButtonUrl, openInNewTab: !!modalButtonUrl }, modalButtonMessage))));
